import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {

  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  const contactUs = () => {
    navigate('/contact');
  };

  const getPrices = () => {
    navigate('/pricing');
  };

  return (
    <header className="header">
      <div className="logo" onClick={goHome}>CodeToCode</div>
      <nav>
        <ul className="nav-links">
          <li><a className='normal-links' onClick={getPrices}>Pricing</a></li>
          <li><a className='normal-links' onClick={contactUs}>Contact</a></li>
          <li><a className="login">Login</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
